
import { Component, Vue } from 'vue-property-decorator';
import PortalHeader from '@/components/Layout/PortalHeader.vue';
import ActiveLoanSelector from '@/components/MultiLoan/ActiveLoanSelector.vue';

@Component({ components: { ActiveLoanSelector, PortalHeader } })
export default class Portal extends Vue {
  get canSwitchLoans(): boolean {
    return this.$route.name === 'home' && this.$store.getters['User/availableLoans'].length > 1;
  }
}
